import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { v7 as uuidv7 } from 'uuid'

import { getIsLogoutInProgress } from '../../data/logout/logoutSelector'
import { setSessionId } from '../../data/session/sessionActions'
import { getSessionId } from '../../data/session/sessionSelectors'
import store from '../../data/storeConfiguration/store'

export const useSessionId = () => {
  const sessionId = useSelector(getSessionId)
  const isLogoutInProgress = useSelector(getIsLogoutInProgress)

  useEffect(() => {
    if (!sessionId) {
      store.dispatch(setSessionId(uuidv7()))
    }
  }, [sessionId])

  useEffect(() => {
    if (isLogoutInProgress) {
      store.dispatch(setSessionId(uuidv7()))
    }
  }, [isLogoutInProgress])
}
